import { useHistory } from 'react-router-dom';
import hasMigrated from '../../../../../utils/routeMatcher';
import appendUTMParams from '../../../../../utils/utmParams';

/**
 * Returns the goTo function.
 * The goTo function is responsible for adding the search result to recent searches and navigating to it's path.
 * @returns {func}
 */
const useGoTo = () => {
  const { push } = useHistory();
  return ({ path }) => {
    const finalPath = appendUTMParams(path);
    if (hasMigrated(finalPath)) {
      window.location.href = finalPath;
    } else {
      push(finalPath);
    }
  };
};

export default useGoTo;
